import { render, staticRenderFns } from "./housePcHeader.vue?vue&type=template&id=5cc128c4&scoped=true&"
import script from "./housePcHeader.vue?vue&type=script&lang=js&"
export * from "./housePcHeader.vue?vue&type=script&lang=js&"
import style0 from "./housePcHeader.vue?vue&type=style&index=0&id=5cc128c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc128c4",
  null
  
)

export default component.exports